import React, { useEffect } from "react";

import { useState,useContext } from "react";
import { useUrlContext } from '../context/urlContext';
import { Typography } from '@mui/material';


import ParentComponent from "../Components/ParentForTableAndFormComponent";
import axios from "axios";
import LocationForm from "../Forms/LocationForm";
import { errorContext } from "../Components/ErrorDisplay";
import { useConfirm } from "../Components/ConfirmDialog";
import { useAuth } from '../context/authContext';

export default function Location(props) {
    const { UrlHelperObj } = useUrlContext();
    const {handleError,setErrorMessage,notify} = useContext(errorContext);
    const confirm = useConfirm();
    const { user } = useAuth();
    // The location list is scoped to the selected CLUB (issuerId), like every
    // other entity in the app. The redemption partner is only a per-location
    // attribute set in the form, not the list's iId.
    const issuerId = user?.issuerId;
    const selectedRedemptionPartnerId = props.RedemptionPartnerRow?.id;
    const[selectedRedemptionPartner,setSelectedRedemptionPartner] = useState(null);
    const [columnInfo, setColumnInfo] = useState([
        {  title: 'Name',dbname:'name' },
        {  title: 'Access',dbname:'access' },
        {  title: 'Scanning Device',dbname:'device_configuration' },
        {  title: 'Shelly Lock',dbname:'shelly_display' },
    ]);
    const[locationRecords,setLocationRecords]=useState([]);
    
    
    /* useEffect(()=>{setSelectedRedemptionPartner(props.RedemptionPartnerRow);
    },[props.RedemptionPartnerRow]); */

    useEffect(()=>{
        if (!issuerId) {
            setLocationRecords([]);
            return;
        }

        getLocationRecords();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[issuerId]);

    function handleLocationRecords(results){
        console.log(results);
        if(results.length === 0)
            setErrorMessage("No record found");
        setLocationRecords(results);
    }

    async function getLocationRecords()
    {
        await axios.get(UrlHelperObj.locationUrl_GET(issuerId))
        .then(response => response.data)
        .then(results => {
            const list = Array.isArray(results?.locations) ? results.locations : [];
            // Scanning Device column shows device_configuration as-is; Shelly Lock
            // shows shelly_configuration, except when access is Manual/None where
            // shelly configuration is not allowed.
            const processed = list.map(loc => {
                const acc = String(loc.access || '').trim().toLowerCase();
                const shellyNotAllowed = acc === 'manual' || acc === 'none';
                return { ...loc, shelly_display: shellyNotAllowed ? 'Not Allowed' : loc.shelly_configuration };
            });
            setLocationRecords(processed);
            console.log("Location records "+JSON.stringify(results));
            // Empty result: notify the user (red, to match the other list pages).
            if (processed.length === 0) {
                notify('No records found', 'error');
            }
        })
        .catch(err => handleError(err));
    }
    async function deleteLocationRecord(record)
    {
        const ok = await confirm({ title: 'Delete location', message: 'Are you sure you want to delete this location?', confirmText: 'Delete' });
        if (!ok) {
            return;
        }
        try {
            await axios.delete(UrlHelperObj.locationUrlById(record))
                .then(response => response.data)
                .then(results => console.log("delete of Location " + record + " successful"));
            props.setSelectedRow(null);
            getLocationRecords();
        } catch (err) {
            handleError(err);
        }
    }
    async function editLocationRecord(record)
    {
        const accessMap = { 'None': 0, 'Auto': 1, 'Manual': 2 };
        const data = {
            id:record.id,
            name:record.name,
            redemption_partner_id:record.redemption_partner_id || selectedRedemptionPartnerId,
            access: record.access ?? accessMap[props.mode] ?? 0,
        };
        console.log("Location edit"+JSON.stringify(record));
        await axios.put(UrlHelperObj.locationUrl(),data)
        .then(response => response.data)
        .then(results =>console.log("Edit of Location "+record+" successful"))
        .catch(err => handleError(err));
        getLocationRecords();
    }
    async function addLocationRecord(record)
    {
           //     name:record.partnerName,
        //     parent_wholesale_brand:record.partnerWholesaleBrandName,
        //     retailer_brand_name:record.retailerBrandName,
        //     location:record.location,
        //     key_contacts:record.contact,
        //     image:record.image
        // };

        // const data = new FormData();
        // data.append("id",0);
        // data.append("name",record.brandName);
        // data.append("issuer_id",record.issuerId);
        const accessMap = { 'None': 0, 'Auto': 1, 'Manual': 2 };
        const data={
            id:0,
            name:record.name,
            redemption_partner_id:record.redemption_partner_id || selectedRedemptionPartnerId,
            access: record.access ?? accessMap[props.mode] ?? 0,
        };
        
        await axios.post(UrlHelperObj.locationUrl(),data,)
        .then(response => response.data)
        .then(results =>console.log("Add of Location "+record+" successful"))
        .catch(err => handleError(err));
        getLocationRecords();
    }
  
    function handleFormSubmit(data,isAddOptr,isCancelOptr)
    {
        
        props.setFormShown(false);
        if(isCancelOptr === true)
        {
            console.log("Cancelled optr");
            return 0;
        }
        
        if(isAddOptr === true)
            addLocationRecord(data);
        else
            editLocationRecord(data);
    }
    
    
    return(
        <>
        {props.noRedemptionPartner && (
            <Typography style={{ color: '#c62828', marginBottom: 8, textAlign: 'left' }}>
                No redemption partner exists for this club. Please add a redemption partner before creating a location.
            </Typography>
        )}
        <ParentComponent
        data={locationRecords}
        columns={columnInfo}
        form={LocationForm}
        formTitle={"Location"}
        handleFormSubmitFunc={handleFormSubmit}
        setFormShownFlag={props.setFormShown}
        deleteFunc={deleteLocationRecord}
        setSelectedRow={props.setSelectedRow}
        selectedRedemptionPartnerRow={props.RedemptionPartnerRow}
        redemptionPartnerList={props.RedemptionPartnerList}
        onRedemptionPartnerChange={props.onRedemptionPartnerChange}
        alreadySelectedOwnRow={props.alreadySelectedOwnRow}
        isAddDisabled={!!props.noRedemptionPartner}
        />
        </>
    );
            
}

